var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_261",
    "data-name": "Grupo 261",
    width: 54.073,
    height: 44.136,
    viewBox: "0 0 54.073 44.136",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_260",
    "data-name": "Grupo 260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_258",
    "data-name": "Grupo 258",
    transform: "translate(1.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M248.252,66.3c4.958-.718,10.9,1.81,13.248,5.634l1.986,3.237-2.1.3L259.4,72.234c-1.8-2.93-6.35-4.865-10.148-4.316l-22.1,3.2c-3.8.549-5.423,3.379-3.624,6.309l10.461,17.044c1.8,2.928,6.348,4.863,10.145,4.314l22.1-3.2c3.8-.55,5.425-3.38,3.628-6.308l-1.987-3.238,2.1-.3,1.987,3.238c2.346,3.822.222,7.518-4.736,8.235l-22.1,3.2c-4.958.718-10.9-1.81-13.245-5.633L221.423,77.73c-2.347-3.824-.225-7.519,4.733-8.236Z",
    transform: "translate(-220.467 -66.173)",
    fill: "#aac208"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_259",
    "data-name": "Grupo 259",
    transform: "translate(0 9.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M243.033,97.739c4.958-.718,10.9,1.81,13.248,5.634l1.986,3.237-2.1.3-1.986-3.237c-1.8-2.93-6.35-4.865-10.148-4.315l-22.1,3.2c-3.8.55-5.423,3.379-3.624,6.309l10.461,17.044c1.8,2.928,6.349,4.863,10.145,4.314l22.1-3.2c3.8-.55,5.425-3.38,3.628-6.308l-1.987-3.238,2.1-.3,1.987,3.238c2.346,3.822.222,7.518-4.736,8.235l-22.1,3.2c-4.958.717-10.9-1.81-13.245-5.633L216.2,109.174c-2.347-3.824-.225-7.519,4.733-8.236Z",
    transform: "translate(-215.248 -97.617)",
    fill: "#aac208"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon.c0346787.svg";
export { ForwardRef as ReactComponent };